import React, { PropTypes } from 'react';

import { AVAILABLE } from './helpers/availabilityTypes';

import Available from './Available';
import NoTickets from './NoTickets';
import NotAvailable from './NotAvailable';

import { bookNow } from './styles.module.css';

/**
 *
 */
const BookNow = props => (
  <div className={bookNow}>
    {props.hasTickets && props.availability === AVAILABLE && (
      <Available {...props} />
    )}
    {props.hasTickets && props.availability !== AVAILABLE && (
      <NotAvailable {...props} />
    )}
    {!props.hasTickets && props.raceSchemaType === 'full' && (
      <NoTickets {...props} />
    )}
  </div>
);

BookNow.propTypes = {
  availability: PropTypes.number.isRequired,
  hasTickets: PropTypes.bool.isRequired,
  raceSchemaType: PropTypes.string.isRequired,
};

export default BookNow;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/component.jsx